"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = convertMSWordToHtml;
exports.extractListItemText = exports.CONVERT_MSWORD_TO_HTML = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _isValidPasteContent = _interopRequireDefault(require("../utils/isValidPasteContent"));

var _parseHTML = _interopRequireDefault(require("../utils/parseHTML"));

var MSFT_LIST_CLASSNAMES = ['MsoListParagraphCxSpFirst', 'MsoListParagraphCxSpMiddle', 'MsoListParagraphCxSpLast'];
var MSFT_IGNORE = /mso-list:Ignore/;
var CONVERT_MSWORD_TO_HTML = 'msword';
/**
 * removes all children that are comments or intended to be ignored by programs
 * that don't know how to handle MS Word lists (we know how :))
 */

exports.CONVERT_MSWORD_TO_HTML = CONVERT_MSWORD_TO_HTML;

var extractListItemText = function extractListItemText(node) {
  var commentNodes = [];
  var childNodes = (0, _toConsumableArray2.default)(node.childNodes);
  childNodes.forEach(function (childNode) {
    if (childNode.outerHTML && childNode.outerHTML.match(MSFT_IGNORE) || childNode.nodeName === '#comment') {
      commentNodes.push(childNode);
    } else if (childNode.childNodes.length) {
      extractListItemText(childNode);
    }
  });
  commentNodes.forEach(function (commentNode) {
    node.removeChild(commentNode);
  });
  return node;
};

exports.extractListItemText = extractListItemText;

var getCleanDocument = function getCleanDocument(dirty) {
  // create a new target document to preserve input integrity
  var body = document.createElement('body');
  var nodes = dirty.childNodes; // need to keep track of whether or not we're in the middle of a list

  var listEl = null; // we can just linearly traverse the childNodes list because the list is a flattened DOM
  // representation, meaning element structure and order is maintained

  for (var i = 0; i < nodes.length; i++) {
    // if the element isn't an MS Word list element we don't need to do any post-processing
    // just clone it and move on
    if (MSFT_LIST_CLASSNAMES.indexOf(nodes[i].className) === -1) {
      body.appendChild(nodes[i].cloneNode(true));
      continue;
    } // otherwise, create a new list item element, extract the text from the list item,
    // and then append that list item to the global list element


    var newListItem = document.createElement('li');
    var textEl = extractListItemText(nodes[i].cloneNode(true));
    newListItem.appendChild(textEl);

    if (!listEl) {
      listEl = document.createElement('ul');
    }

    listEl.appendChild(newListItem);

    if (nodes[i].className === 'MsoListParagraphCxSpLast') {
      // if we're at the end of a list, append the list to the body and
      // then remove the reference for the next time through the loop
      body.appendChild(listEl);
      listEl = null;
    }
  }

  return body;
};

function convertMSWordToHtml(clipboardContent) {
  (0, _isValidPasteContent.default)(clipboardContent);
  return getCleanDocument((0, _parseHTML.default)(clipboardContent.replace(/(\r\n|\n|\r)/, ''))).outerHTML;
}